import { render, staticRenderFns } from "./SelectBoxCommentTemplate.vue?vue&type=template&id=0d034020"
import script from "./SelectBoxCommentTemplate.vue?vue&type=script&lang=js"
export * from "./SelectBoxCommentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports